/**
 * Colours for the dashboard's farm benchmark card.
 *
 * Green and orange are spent on one thing only: which side of the other farms' average this farm is on,
 * read through `lowerIsBetter`. Everything describing the other farms is grey, so the farm is the only
 * coloured mark in a row. Never red: being under the average is a prompt to look, not a failure.
 */
export const farmBenchmarkColors = {
  /** green-600 - the farm is on the good side of the average. */
  better: '#16a34a',

  /** orange-500 - the farm is on the bad side of the average. */
  worse: '#f97316',

  /** gray-400 - no average to compare with, or exactly on it. */
  neutral: '#9ca3af',

  /** gray-200 - the other farms' lowest-to-highest band. */
  range: '#e5e7eb',

  /** gray-700 - the other farms' average. */
  average: '#374151',

  /** gray-100 - the empty track behind the bar. */
  track: '#f3f4f6'
};

export type FarmBenchmarkStanding = 'better' | 'worse' | 'neutral';
